import type { Experience } from '@experience/exp-card/dist/types/experience';

export const SELECTION_BLOCK_TYPES = {
  AUTO: 'auto',
  MANUAL: 'manual',
} as const;

export type SelectionBlockType = (typeof SELECTION_BLOCK_TYPES)[keyof typeof SELECTION_BLOCK_TYPES];
export const SELECTION_TYPE = {
  TOUR: 'tour',
  GROUP: 'group',
  PRIVATE: 'private',
} as const;

export type SelectionType = (typeof SELECTION_TYPE)[keyof typeof SELECTION_TYPE];

export interface IExpSelection {
  isAuto: boolean;
  expTotalCount: number;
  experiences: Experience[];
  link: string;
  selectionType: string;
  subtitle?: string;
  title: string;
  type: string;
  extendedSoguParams: {
    block_type: SelectionBlockType;
    section_name: string;
    tag_id: number | null;
  };
  extra_data?: {
    tag_id?: number | null;
    tag_slug?: string | null;
  };
}
